// noinspection RequiredAttributes

import { html, View } from 'rune-ts';
import klass from './ProductImageView.module.scss';
import { classes, htmlIf } from '@services/MarppleShop/shared/util';
import {
  BadgeMainView,
  TBadgeMainWithoutSize,
} from '@services/MarppleShop/renderApp/pages/Curation/components/BadgeMainView.ts';
import { LikeView } from '@services/MarppleShop/renderApp/pages/Curation/components/LikeView.ts';
import { staticFont } from '@services/MarppleShop/shared/typography';
import { ProductThumbnail } from '@services/MarppleShop/features/ProductList/type';
import { thumbnailViewTransformer } from '@services/MarppleShop/renderApp/components/cells/ProductThumbnail/transform/thumbnailViewTransformer.ts';
import { pipe } from '@fxts/core';
import { makeSubScreenNavigate } from '@services/MarppleShop/shared/app/navigate.ts';
import { dataStr } from '@services/MarppleShop/shared/util/dataStr.ts';
import { ELang } from '@services/MarppleShop/shared/enum/ELang.ts';
import { assert } from '@services/MarppleShop/shared/util/assert.ts';
import { CardProductError } from '@services/MarppleShop/renderApp/pages/Curation/components/CardProductView.ts';

export type TProps =
  | {
      state: 'Default';
      size: 'Xlarge~Large';
      thumbnail_info: ProductThumbnail;
      is_liked: boolean;
      is_lazy: boolean;
      resize_width: number;
      domain_name: string;
      id: number;
      badge_main_without_size?: TBadgeMainWithoutSize;
      name: string;
      store_name: string;
      onLikeClick: () => void;
    }
  | {
      state: 'Adult';
      size: 'Xlarge~Large';
      thumbnail_info: ProductThumbnail;
      is_liked: boolean;
      is_lazy: boolean;
      resize_width: number;
      domain_name: string;
      id: number;
      badge_main_without_size?: TBadgeMainWithoutSize;
      name: string;
      store_name: string;
      onLikeClick: () => void;
    }
  | {
      state: 'Soldout';
      size: 'Xlarge~Large';
      thumbnail_info: ProductThumbnail;
      is_liked: boolean;
      is_lazy: boolean;
      resize_width: number;
      domain_name: string;
      id: number;
      badge_main_without_size?: TBadgeMainWithoutSize;
      name: string;
      store_name: string;
      onLikeClick: () => void;
    }
  | {
      state: 'Soldout+Adult';
      size: 'Xlarge~Large';
      thumbnail_info: ProductThumbnail;
      is_liked: boolean;
      is_lazy: boolean;
      resize_width: number;
      domain_name: string;
      id: number;
      badge_main_without_size?: TBadgeMainWithoutSize;
      name: string;
      store_name: string;
      onLikeClick: () => void;
    }
  | {
      state: 'Default';
      size: 'Medium~Small';
      thumbnail_info: ProductThumbnail;
      is_liked: boolean;
      is_lazy: boolean;
      resize_width: number;
      domain_name: string;
      id: number;
      badge_main_without_size?: TBadgeMainWithoutSize;
      name: string;
      store_name: string;
      onLikeClick: () => void;
    }
  | {
      state: 'Adult';
      size: 'Medium~Small';
      thumbnail_info: ProductThumbnail;
      is_liked: boolean;
      is_lazy: boolean;
      resize_width: number;
      domain_name: string;
      id: number;
      badge_main_without_size?: TBadgeMainWithoutSize;
      name: string;
      store_name: string;
      onLikeClick: () => void;
    }
  | {
      state: 'Soldout';
      size: 'Medium~Small';
      thumbnail_info: ProductThumbnail;
      is_liked: boolean;
      is_lazy: boolean;
      resize_width: number;
      domain_name: string;
      id: number;
      badge_main_without_size?: TBadgeMainWithoutSize;
      name: string;
      store_name: string;
      onLikeClick: () => void;
    }
  | {
      state: 'Soldout+Adult';
      size: 'Medium~Small';
      thumbnail_info: ProductThumbnail;
      is_liked: boolean;
      is_lazy: boolean;
      resize_width: number;
      domain_name: string;
      id: number;
      badge_main_without_size?: TBadgeMainWithoutSize;
      name: string;
      store_name: string;
      onLikeClick: () => void;
    }
  | {
      state: 'Default';
      size: 'Xsmall';
      thumbnail_info: ProductThumbnail;
      is_liked: boolean;
      is_lazy: boolean;
      resize_width: number;
      domain_name: string;
      id: number;
      badge_main_without_size?: TBadgeMainWithoutSize;
      name: string;
      store_name: string;
      onLikeClick: () => void;
    }
  | {
      state: 'Adult';
      size: 'Xsmall';
      thumbnail_info: ProductThumbnail;
      is_liked: boolean;
      is_lazy: boolean;
      resize_width: number;
      domain_name: string;
      id: number;
      badge_main_without_size?: TBadgeMainWithoutSize;
      name: string;
      store_name: string;
      onLikeClick: () => void;
    }
  | {
      state: 'Soldout';
      size: 'Xsmall';
      thumbnail_info: ProductThumbnail;
      is_liked: boolean;
      is_lazy: boolean;
      resize_width: number;
      domain_name: string;
      id: number;
      badge_main_without_size?: TBadgeMainWithoutSize;
      name: string;
      store_name: string;
      onLikeClick: () => void;
    }
  | {
      state: 'Soldout+Adult';
      size: 'Xsmall';
      thumbnail_info: ProductThumbnail;
      is_liked: boolean;
      is_lazy: boolean;
      resize_width: number;
      domain_name: string;
      id: number;
      badge_main_without_size?: TBadgeMainWithoutSize;
      name: string;
      store_name: string;
      onLikeClick: () => void;
    }
  | {
      state: 'Default';
      size: 'Small';
      thumbnail_info: ProductThumbnail;
      is_liked: boolean;
      is_lazy: boolean;
      resize_width: number;
      domain_name: string;
      id: number;
      name: string;
      store_name: string;
      onLikeClick: () => void;
    }
  | {
      state: 'Adult';
      size: 'Small';
      thumbnail_info: ProductThumbnail;
      is_liked: boolean;
      is_lazy: boolean;
      resize_width: number;
      domain_name: string;
      id: number;
      name: string;
      store_name: string;
      onLikeClick: () => void;
    }
  | {
      state: 'Soldout';
      size: 'Small';
      thumbnail_info: ProductThumbnail;
      is_liked: boolean;
      is_lazy: boolean;
      resize_width: number;
      domain_name: string;
      id: number;
      name: string;
      store_name: string;
      onLikeClick: () => void;
    }
  | {
      state: 'Soldout+Adult';
      size: 'Small';
      thumbnail_info: ProductThumbnail;
      is_liked: boolean;
      is_lazy: boolean;
      resize_width: number;
      domain_name: string;
      id: number;
      name: string;
      store_name: string;
      onLikeClick: () => void;
    };

/**
 * https://www.figma.com/design/J3pxvmlv167DXuLToyL3Mg/%EC%83%81%ED%92%88-%EC%B9%B4%EB%93%9C-UI?node-id=386-51861&m=dev
 */
export class ProductImageView extends View<TProps> {
  private like_view: LikeView;

  private badge_main_view: BadgeMainView | null = null;

  constructor(props: TProps) {
    super(props);

    if (props.size === 'Xlarge~Large') {
      this.like_view = new LikeView({ state: props.is_liked ? 'On' : 'Off', size: 'Large' });
      if (props.badge_main_without_size) {
        this.badge_main_view = new BadgeMainView({
          ...props.badge_main_without_size,
          size: 'Large (Xlarge~Large)',
        });
      }
    } else if (props.size === 'Medium~Small' || props.size === 'Xsmall') {
      this.like_view = new LikeView({ state: props.is_liked ? 'On' : 'Off', size: 'Medium' });
      if (props.badge_main_without_size) {
        this.badge_main_view = new BadgeMainView({
          ...props.badge_main_without_size,
          size: 'Medium (Medium~Small)',
        });
      }
    } else if (props.size === 'Small') {
      this.like_view = new LikeView({ state: props.is_liked ? 'On' : 'Off', size: 'Small' });
    } else {
      throw new CardProductError();
    }
  }

  setIsLiked(is_liked: boolean) {
    this.data.is_liked = is_liked;
    this.like_view.setState(is_liked ? 'On' : 'Off');
  }

  setBadgeMainWithoutSize(badge_main_without_size: TBadgeMainWithoutSize) {
    assert(
      this.data.size === 'Xlarge~Large' || this.data.size === 'Medium~Small' || this.data.size === 'Xsmall',
      new CardProductError(),
    );

    this.data.badge_main_without_size = badge_main_without_size;
    if (this.badge_main_view) {
      this.badge_main_view.setBadgeMainWithoutSize(badge_main_without_size);
    } else {
      const container = this.element().querySelector(`.${klass.badge_main_wrapper}`);
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      container!.append(
        new BadgeMainView({
          ...badge_main_without_size,
          size: this.data.size === 'Xlarge~Large' ? 'Large (Xlarge~Large)' : 'Medium (Medium~Small)',
        }).render(),
      );
    }
  }

  protected override onRender() {
    this.delegate('click', `.${klass.like_wrapper}`, () => this.data.onLikeClick());
  }

  protected override template(props: TProps) {
    const dimensions = thumbnailViewTransformer.calculateDimensions(
      props.thumbnail_info.scale,
      props.resize_width,
    );

    const img_style = thumbnailViewTransformer.createStyle(props.thumbnail_info, dimensions);

    const resized_img_url = thumbnailViewTransformer.createResizedUrl(props.thumbnail_info, dimensions);

    const img_href = `/${props.domain_name}/products/${props.id}`;

    const img_data_post_message = pipe(img_href, makeSubScreenNavigate, dataStr);

    const img_alt = `${props.store_name}, ${props.name}${T.lang === ELang.Kr ? ' 굿즈, 굿즈 판매, 굿즈샵' : ''}`;

    if (
      props.state === 'Default' &&
      (props.size === 'Xlarge~Large' || props.size === 'Medium~Small' || props.size === 'Xsmall')
    ) {
      const { thumbnail_info, is_lazy } = props;

      return html`<div
        class="${classes(klass.product_image, {
          [klass.size_xlarge_large]: props.size === 'Xlarge~Large',
          [klass.size_medium_small]: props.size === 'Medium~Small',
          [klass.size_xsmall]: props.size === 'Xsmall',
        })}"
      >
        <div
          class="${classes(klass.badge_main_wrapper, {
            [klass.size_xlarge_large]: props.size === 'Xlarge~Large',
            [klass.size_medium_small]: props.size === 'Medium~Small',
            [klass.size_xsmall]: props.size === 'Xsmall',
          })}"
        >
          ${this.badge_main_view}
        </div>

        <button
          type="button"
          class="${classes(klass.like_wrapper, {
            [klass.size_xlarge_large]: props.size === 'Xlarge~Large',
            [klass.size_medium_small]: props.size === 'Medium~Small',
            [klass.size_xsmall]: props.size === 'Xsmall',
          })}"
        >
          ${this.like_view}
        </button>

        <a class="${klass.image_wrapper}" href="${img_href}" data-post-message="${img_data_post_message}">
          <img
            alt="${img_alt}"
            class="${klass.image} ${htmlIf('lazy-src', is_lazy)}"
            ${is_lazy ? 'data-src' : 'src'}="${resized_img_url}"
            ${thumbnail_info
              ? html`data-composite_template_id="${thumbnail_info.composite_template_id}"`
              : ''}
            style="${img_style}"
          />
        </a>
      </div>`;
    } else if (
      props.state === 'Adult' &&
      (props.size === 'Xlarge~Large' || props.size === 'Medium~Small' || props.size === 'Xsmall')
    ) {
      const { thumbnail_info, is_lazy } = props;

      return html`<div
        class="${classes(klass.product_image, {
          [klass.size_xlarge_large]: props.size === 'Xlarge~Large',
          [klass.size_medium_small]: props.size === 'Medium~Small',
          [klass.size_xsmall]: props.size === 'Xsmall',
        })}"
      >
        <div
          class="${classes(klass.badge_main_wrapper, {
            [klass.size_xlarge_large]: props.size === 'Xlarge~Large',
            [klass.size_medium_small]: props.size === 'Medium~Small',
            [klass.size_xsmall]: props.size === 'Xsmall',
          })}"
        >
          ${this.badge_main_view}
        </div>

        <button
          type="button"
          class="${classes(klass.like_wrapper, {
            [klass.size_xlarge_large]: props.size === 'Xlarge~Large',
            [klass.size_medium_small]: props.size === 'Medium~Small',
            [klass.size_xsmall]: props.size === 'Xsmall',
          })}"
        >
          ${this.like_view}
        </button>

        <a class="${klass.image_wrapper}" href="${img_href}" data-post-message="${img_data_post_message}">
          <img
            alt="${img_alt}"
            class="${klass.image} ${htmlIf('lazy-src', is_lazy)}"
            ${is_lazy ? 'data-src' : 'src'}="${resized_img_url}"
            ${thumbnail_info
              ? html`data-composite_template_id="${thumbnail_info.composite_template_id}"`
              : ''}
            style="${img_style}"
          />
        </a>
      </div>`;
    } else if (
      props.state === 'Soldout' &&
      (props.size === 'Xlarge~Large' || props.size === 'Medium~Small' || props.size === 'Xsmall')
    ) {
      const { thumbnail_info, is_lazy } = props;

      return html`<div
        class="${classes(klass.product_image, {
          [klass.size_xlarge_large]: props.size === 'Xlarge~Large',
          [klass.size_medium_small]: props.size === 'Medium~Small',
          [klass.size_xsmall]: props.size === 'Xsmall',
        })}"
      >
        <div
          class="${classes(
            klass.dim_soldout,
            staticFont(props.size === 'Xlarge~Large' ? 'bebas_32_bold' : 'bebas_20_bold'),
          )}"
        >
          SOLD OUT
        </div>

        <div
          class="${classes(klass.badge_main_wrapper, {
            [klass.size_xlarge_large]: props.size === 'Xlarge~Large',
            [klass.size_medium_small]: props.size === 'Medium~Small',
            [klass.size_xsmall]: props.size === 'Xsmall',
          })}"
        >
          ${this.badge_main_view}
        </div>

        <button
          type="button"
          class="${classes(klass.like_wrapper, {
            [klass.size_xlarge_large]: props.size === 'Xlarge~Large',
            [klass.size_medium_small]: props.size === 'Medium~Small',
            [klass.size_xsmall]: props.size === 'Xsmall',
          })}"
        >
          ${this.like_view}
        </button>

        <a class="${klass.image_wrapper}" href="${img_href}" data-post-message="${img_data_post_message}">
          <img
            alt="${img_alt}"
            class="${klass.image} ${htmlIf('lazy-src', is_lazy)}"
            ${is_lazy ? 'data-src' : 'src'}="${resized_img_url}"
            ${thumbnail_info
              ? html`data-composite_template_id="${thumbnail_info.composite_template_id}"`
              : ''}
            style="${img_style}"
          />
        </a>
      </div>`;
    } else if (
      props.state === 'Soldout+Adult' &&
      (props.size === 'Xlarge~Large' || props.size === 'Medium~Small' || props.size === 'Xsmall')
    ) {
      const { thumbnail_info, is_lazy } = props;

      return html`<div
        class="${classes(klass.product_image, {
          [klass.size_xlarge_large]: props.size === 'Xlarge~Large',
          [klass.size_medium_small]: props.size === 'Medium~Small',
          [klass.size_xsmall]: props.size === 'Xsmall',
        })}"
      >
        <div
          class="${classes(
            klass.dim_soldout,
            staticFont(props.size === 'Xlarge~Large' ? 'bebas_32_bold' : 'bebas_20_bold'),
          )}"
        >
          SOLD OUT
        </div>

        <div
          class="${classes(klass.badge_main_wrapper, {
            [klass.size_xlarge_large]: props.size === 'Xlarge~Large',
            [klass.size_medium_small]: props.size === 'Medium~Small',
            [klass.size_xsmall]: props.size === 'Xsmall',
          })}"
        >
          ${this.badge_main_view}
        </div>

        <button
          type="button"
          class="${classes(klass.like_wrapper, {
            [klass.size_xlarge_large]: props.size === 'Xlarge~Large',
            [klass.size_medium_small]: props.size === 'Medium~Small',
            [klass.size_xsmall]: props.size === 'Xsmall',
          })}"
        >
          ${this.like_view}
        </button>

        <a class="${klass.image_wrapper}" href="${img_href}" data-post-message="${img_data_post_message}">
          <img
            alt="${img_alt}"
            class="${klass.image} ${htmlIf('lazy-src', is_lazy)}"
            ${is_lazy ? 'data-src' : 'src'}="${resized_img_url}"
            ${thumbnail_info
              ? html`data-composite_template_id="${thumbnail_info.composite_template_id}"`
              : ''}
            style="${img_style}"
          />
        </a>
      </div>`;
    } else if (props.state === 'Default' && props.size === 'Small') {
      const { thumbnail_info, is_lazy } = props;

      return html`<div class="${classes(klass.product_image, klass.size_small)}">
        <button type="button" class="${classes(klass.like_wrapper, klass.size_small)}">
          ${this.like_view}
        </button>

        <a class="${klass.image_wrapper}" href="${img_href}" data-post-message="${img_data_post_message}">
          <img
            alt="${img_alt}"
            class="${klass.image} ${htmlIf('lazy-src', is_lazy)}"
            ${is_lazy ? 'data-src' : 'src'}="${resized_img_url}"
            ${thumbnail_info
              ? html`data-composite_template_id="${thumbnail_info.composite_template_id}"`
              : ''}
            style="${img_style}"
          />
        </a>
      </div>`;
    } else if (props.state === 'Adult' && props.size === 'Small') {
      const { thumbnail_info, is_lazy } = props;

      return html`<div class="${classes(klass.product_image, klass.size_small)}">
        <button type="button" class="${classes(klass.like_wrapper, klass.size_small)}">
          ${this.like_view}
        </button>

        <a class="${klass.image_wrapper}" href="${img_href}" data-post-message="${img_data_post_message}">
          <img
            alt="${img_alt}"
            class="${klass.image} ${htmlIf('lazy-src', is_lazy)}"
            ${is_lazy ? 'data-src' : 'src'}="${resized_img_url}"
            ${thumbnail_info
              ? html`data-composite_template_id="${thumbnail_info.composite_template_id}"`
              : ''}
            style="${img_style}"
          />
        </a>
      </div>`;
    } else if (props.state === 'Soldout' && props.size === 'Small') {
      const { thumbnail_info, is_lazy } = props;

      return html`<div class="${classes(klass.product_image, klass.size_small)}">
        <button type="button" class="${classes(klass.dim_soldout, staticFont('bebas_16_bold'))}">
          SOLD OUT
        </button>

        <div class="${classes(klass.like_wrapper, klass.size_small)}">${this.like_view}</div>

        <a class="${klass.image_wrapper}" href="${img_href}" data-post-message="${img_data_post_message}">
          <img
            alt="${img_alt}"
            class="${klass.image} ${htmlIf('lazy-src', is_lazy)}"
            ${is_lazy ? 'data-src' : 'src'}="${resized_img_url}"
            ${thumbnail_info
              ? html`data-composite_template_id="${thumbnail_info.composite_template_id}"`
              : ''}
            style="${img_style}"
          />
        </a>
      </div>`;
    } else if (props.state === 'Soldout+Adult' && props.size === 'Small') {
      const { thumbnail_info, is_lazy } = props;

      return html`<div class="${classes(klass.product_image, klass.size_small)}">
        <div class="${classes(klass.dim_soldout, staticFont('bebas_16_bold'))}">SOLD OUT</div>

        <button type="button" class="${classes(klass.like_wrapper, klass.size_small)}">
          ${this.like_view}
        </button>

        <a class="${klass.image_wrapper}" href="${img_href}" data-post-message="${img_data_post_message}">
          <img
            alt="${img_alt}"
            class="${klass.image} ${htmlIf('lazy-src', is_lazy)}"
            ${is_lazy ? 'data-src' : 'src'}="${resized_img_url}"
            ${thumbnail_info
              ? html`data-composite_template_id="${thumbnail_info.composite_template_id}"`
              : ''}
            style="${img_style}"
          />
        </a>
      </div>`;
    } else {
      throw new CardProductError();
    }
  }
}
